import { pdfjs } from "react-pdf";

// Single place that points pdf.js at its worker. Every component that renders
// PDFs through react-pdf should call this instead of setting
// pdfjs.GlobalWorkerOptions.workerSrc itself.
//
// Served from public/ rather than fetched from a CDN: a CDN outage or a
// corporate firewall block would otherwise break every PDF preview in the
// app, and pinning a URL to a specific pdf.js version is a landmine on the
// next upgrade (cdnjs stopped publishing pdf.worker.min.js, renamed to .mjs,
// for pdf.js >= 4.x). public/pdf.worker.min.js is copied from pdfjs-dist by
// scripts/copyPdfWorker.js (wired as postinstall) so it always matches the
// installed pdfjs-dist version — pdf.js requires the worker and API versions
// to match exactly.
let configured = false;

export const configurePdfWorker = () => {
  if (configured) return;
  configured = true;
  pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
};
